import { useBusItem } from './mixins/useBusItem.js'
import { useDispatch } from 'stimulus-use'
import { flashError } from '@app/javascript/classes/flashMessages'
import Rails from '@rails/ujs'
import ApplicationController from '@app/javascript/controllers/application_controller'

export default class extends ApplicationController {
  static targets = ['loadingTemplate', 'targetAreaLoadingTemplate']

  static values = {
    url: String,
    urlParams: Object,
    data: Object,
    targetArea: String,
    settings: Object,
    busItemId: String,
    loadOnConnect: Boolean,
    onErrorAlertMessage: String /* If this has a value and the loading fails,
                                    the controller will display an alert with the value of this stimulus value. */
  }

  initialize() {
    this.element[this.identifier] = this
    if (this.hasLoadingTemplateTarget) {
      this._loadingTemplate = this.loadingTemplateTarget.cloneNode(true)
      this.loadingTemplateTarget.remove()
    }
  }

  doConnect() {
    useBusItem(this)
    useDispatch(this)

    if (this._loadingTemplate) { this.element.innerHTML = this._loadingTemplate.outerHTML }

    if (!this.hasLoadOnConnectValue || this.loadOnConnectValue) {
      this.load()
    }
  }

  disconnect() {
    this.removeFromBus()
  }

  loadTargetArea() {
    this._targetArea = document.querySelector(
      `[data-content-loader-target-area="${this.targetAreaValue}"]`
    )

    if (this.hasTargetAreaLoadingTemplateTarget) {
      this._targetArea.innerHTML = this.targetAreaLoadingTemplateTarget.outerHTML
    }

    this._request((html) => {
      this._targetArea.innerHTML = html.body.innerHTML
    })
  }

  // To be used when (re)loading the content after a subscribed-to event is fired.
  // We want to (re)load only the content-loaders that have actually subscribed to that
  // event via the Stimulus data-action attribute. This is important for content-loaders
  // because there can be a number of content-loaders elements nested in the DOM.
  loadAfterEvent(event) {
    if (this.element.getAttribute('data-action')?.includes(event.type)) {
      this.load()
    }
  }

  load() {
    if (this._loadingTemplate) { this.element.innerHTML = this._loadingTemplate.outerHTML }

    this._request((html) => {
      this.element.innerHTML = html.body.innerHTML
    })
  }

  loadAdjacent(position = 'beforeend') {
    if (this._loadingTemplate) {
      this.element.insertAdjacentHTML(position, this._loadingTemplate.outerHTML)
    }
    this._request((html) => {
      if (this._loadingTemplate && this.hasLoadingTemplateTarget) { this.loadingTemplateTarget.remove() }
      this.element.insertAdjacentHTML(position, html.body.innerHTML)
    })
  }

  reload(newUrlParams = null) {
    if (newUrlParams) {
      this.urlParamsValue = newUrlParams // NOTE: should be the deserialized JSON object here.
    }

    this.load()
  }

  // PRIVATE
  get _settings() {
    return {
      data: this._data,
      url: this.urlValue + this._urlParams,
      type: this._type,
      dataType: 'html'
    }
  }

  get _urlParams() {
    if (this.hasUrlParamsValue) { return '?' + $.param(this.urlParamsValue) }
    return ''
  }

  get _type() {
    const type = (this.settingsValue)?.type
    if (type) { return type }
    return 'get'
  }

  get _data() {
    const data = $.param(this.dataValue || {})
    return data
  }

  _request(doneCallback) {
    Rails.ajax({
      ...this._settings,
      success: (response) => {
        doneCallback(response)
        this.dispatch('loaded')
      },
      error: (error) => {
        if (this.hasOnErrorMessageAlertValue) {
          flashError(this.onErrorMessageAlertValue)
        }
        console.error('Error:', error)
      }
    })
  }
}
